import { render, staticRenderFns } from "./orders-list.vue?vue&type=template&id=758903ab&scoped=true"
import script from "./orders-list.vue?vue&type=script&lang=js"
export * from "./orders-list.vue?vue&type=script&lang=js"
import style0 from "./orders-list.vue?vue&type=style&index=0&id=758903ab&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "758903ab",
  null
  
)

export default component.exports